import { useUserContext } from '@/contexts/user';
import { useWorkspaceContext } from '@/contexts/workspace';
import { computeBlockedModulesActive } from '@/config/blockedModules';

type UseBlockedModule = {
  isFeatureEnabled: boolean;
};

export const useBlockedModule = (): UseBlockedModule => {
  const { userSession } = useUserContext();
  const isView = Boolean(useWorkspaceContext()?.workspace?.defaultWorkspace?.parentId);
  return {
    isFeatureEnabled: !isView && computeBlockedModulesActive(userSession?.country),
  };
};
